import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import { connect } from 'react-redux';

import {updateOtherInfo, toggleLifeCircumstances, saveOtherInfo} from '../actions';
import FormSectionStatus from './FormSectionStatus';
import ForeignLanguage from './ForeignLanguage';
import Teas from './Teas';
import { OtherValidation } from "../validation/otherValidation";

class OtherInfo extends Component {
  constructor(props){
    super(props);
    this.handleLifeCircumstancesToggle = this.handleLifeCircumstancesToggle.bind(this);
    this.saveAndContinue = this.saveAndContinue.bind(this);
    OtherInfo.getValidationState = OtherInfo.getValidationState.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e){
    const {dispatch} = this.props;
    let updates = {};
    updates[e.target.id] = e.target.value;
    dispatch(updateOtherInfo(updates));
  }

  handleLifeCircumstancesToggle(){
    this.props.dispatch(toggleLifeCircumstances());
  }

  saveAndContinue(e){
    e.preventDefault();
    if(OtherInfo.getValidationState() === 'success') {
      console.log('Update Database');
      this.props.dispatch(saveOtherInfo(this.props.otherInfo));
      //this.props.nextStep();
    } else {
      console.log('Not Saved');
    }
  }

  static getValidationState(){
    return 'success';
  }

  render() {
    const { otherInfo } = this.props;
    const validationStatus = new OtherValidation().getValidationStatus(otherInfo);

    return (
      <div>
        <h2>Other Information</h2>
        <Panel>
          <h4>Life Circumstances <small>Maximum Points: 2.5</small></h4>
          <p>Everyone receives 2.5 points.</p>
          <div className="clearfix"></div>
          <hr/>
          <h4>Foreign Language Proficiency <small>Maximum Points: 2.5</small></h4>
          <p>If you are proficient in more than one of the following languages, check all that apply.</p>
          <p className="text-danger">ENGLISH does not qualify as another language.</p>
          <ForeignLanguage dispatch={this.props.dispatch} foreignLanguage={otherInfo.foreignLanguage}/>
          <div className="clearfix"></div>
          <hr/>
          <h4>Test of Essential Academic Skills (TEAS) <small>Maximum Points: 30</small></h4>
          <p>All students applying for the SJDC ADN program must meet the minimum passing score on the Test of Essential Academic Skills (TEAS). <em>If you have taken the TEAS test more than once, please report the HIGHEST of the first three (3) passing scores.</em></p>
          <Teas dispatch={this.props.dispatch} teas={otherInfo.teas}/>
        </Panel>
        <FormSectionStatus {...validationStatus.section}/>
      </div>
    );
  };
}

export default connect(
  (state) => {
    return state;
  }
)(OtherInfo);